import React from "react";
import { Link } from "react-router-dom";

const fallbackTiles = [
  {
    title: "No data available",
    description: "This space will populate once activity starts.",
  },
  {
    title: "Products",
    description: "Nothing has been published in this lane yet.",
  },
  {
    title: "Shops",
    description: "Seller activity will appear here when it is available.",
  },
  {
    title: "Insights",
    description: "Metrics and reporting will show up after the first run.",
  },
];

const panelStyle = {
  background: "rgba(255, 255, 255, 0.04)",
  border: "1px solid rgba(255, 255, 255, 0.08)",
  padding: "24px",
  color: "var(--text-color)",
};

const titleStyle = {
  fontSize: "1.1rem",
  fontWeight: 700,
  marginBottom: "10px",
  color: "var(--text-color)",
};

const descriptionStyle = {
  margin: 0,
  lineHeight: 1.6,
  color: "rgba(255, 255, 255, 0.72)",
};

const actionStyle = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  marginTop: "18px",
  padding: "10px 16px",
  borderRadius: "999px",
  background: "#ffffff",
  color: "#111111",
  fontWeight: 700,
  textDecoration: "none",
  border: "none",
  cursor: "pointer",
};

const renderTile = (tile, index) => (
  <div key={`${tile.title}-${index}`} className="bento-box" style={panelStyle}>
    <div>
      <h3 style={titleStyle}>{tile.title}</h3>
      <p style={descriptionStyle}>{tile.description}</p>
    </div>
  </div>
);

const BentoEmptyState = ({
  title = "No data available",
  description = "Nothing is ready to display here yet.",
  tiles = fallbackTiles,
  actionLabel,
  actionTo,
  onAction,
}) => {
  const normalizedTiles = [...tiles, ...fallbackTiles].slice(0, 4);

  return (
    <section className="explore-bento-section">
      <div className="explore-bento-container">
        <div className="bento-container" style={{ height: "auto", minHeight: "340px" }}>
          <div className="bento-column bento-column-left" style={panelStyle}>
            <div>
              <h2 className="bento-title" style={{ marginTop: 0, marginBottom: "12px" }}>
                {title}
              </h2>
              <p style={descriptionStyle}>{description}</p>
              {actionLabel && actionTo ? (
                <Link to={actionTo} style={actionStyle}>
                  {actionLabel}
                </Link>
              ) : null}
              {actionLabel && !actionTo && onAction ? (
                <button type="button" onClick={onAction} style={actionStyle}>
                  {actionLabel}
                </button>
              ) : null}
            </div>
          </div>
          <div className="bento-middle">
            {renderTile(normalizedTiles[0], 0)}
            {renderTile(normalizedTiles[1], 1)}
          </div>
          <div className="bento-column bento-column-right" style={{ gap: "10px" }}>
            {renderTile(normalizedTiles[2], 2)}
            {renderTile(normalizedTiles[3], 3)}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BentoEmptyState;